<a class="skip-link" href="#main-content">Pular para conteúdo principal</a>
<ng-container *ngIf="!isLoginRoute(); else loginOnly">
  <mat-sidenav-container class="layout-container">
    <mat-sidenav #drawer class="app-sidenav" mode="over" position="start" role="navigation" aria-label="Menu de navegação">
      <div class="sidenav-header">
        <h2>Gestor</h2>
        <p class="sidenav-sub">Cobrança</p>
      </div>
      <mat-nav-list>
        <a mat-list-item routerLink="/dashboard" routerLinkActive="active" (click)="drawer.close()">
          <mat-icon matListIcon aria-hidden="true">dashboard</mat-icon>
          <span>Dashboard</span>
        </a>
        <a mat-list-item routerLink="/pessoas" routerLinkActive="active" (click)="drawer.close()">
          <mat-icon matListIcon aria-hidden="true">groups</mat-icon>
          <span>Clientes</span>
        </a>
        <a mat-list-item routerLink="/cobrancas" routerLinkActive="active" (click)="drawer.close()">
          <mat-icon matListIcon aria-hidden="true">paid</mat-icon>
          <span>Cobranças</span>
        </a>
        <a mat-list-item routerLink="/parcelamento" routerLinkActive="active" (click)="drawer.close()">
          <mat-icon matListIcon aria-hidden="true">credit_card</mat-icon>
          <span>Parcelamentos</span>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item (click)="logout(); drawer.close()">
          <mat-icon matListIcon aria-hidden="true">logout</mat-icon>
          <span>Sair</span>
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <app-top-bar (menuToggle)="drawer.toggle()"></app-top-bar>
      <main id="main-content" role="main">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
<ng-template #loginOnly>
  <router-outlet></router-outlet>
</ng-template>

<!-- Global Spinner -->
<div 
  *ngIf="(spinnerState$ | async)?.isLoading" 
  class="global-spinner-container"
  role="alert"
  aria-live="assertive"
  aria-label="Carregando"
  [class.global-spinner-container--fullscreen]="(spinnerState$ | async)?.fullScreen"
  [class.global-spinner-container--overlay]="(spinnerState$ | async)?.overlay">
  
  <div class="global-spinner">
    <div class="global-spinner__dot"></div>
    <div class="global-spinner__dot"></div>
    <div class="global-spinner__dot"></div>
    <div class="global-spinner__dot"></div>
  </div>
  
  <div class="global-spinner-message" *ngIf="(spinnerState$ | async)?.message">
    <p>{{ (spinnerState$ | async)?.message }}</p>
  </div>
</div>

